import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
	view: z.string().optional(),
	id: z.string().optional(),
	state: z.string().optional(),
	// Review-only viewport toggle used by prototypes that carry a phone-width variant.
	phone: z.boolean().optional(),
});

const Screen = import.meta.env.DEV
	? lazy(() => import('@/prototype/_kit/host').then((m) => ({ default: m.PrototypeScreen })))
	: () => null;

export const Route = createFileRoute('/prototype/$slug/$screen')({
	validateSearch: searchSchema,
	component: Screen,
});
